import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Container, Grid, TextField } from '@material-ui/core';

import { Creators as ComponentActions } from '~/store/modules/component/ducks';

import ResourceContext from '../index.context';

export default function QuestionsComponent() {
  const dispatch = useDispatch();
  const { setStep } = useContext(ResourceContext);
  const currentComponent = useSelector((state) => state.component.current);
  const { resource } = currentComponent;

  const setData = ({ name, value }) => {
    dispatch(
      ComponentActions.setComponentKindData({ kind: 'resource', name, value })
    );
  };

  return (
    <Container>
      <Box
        width={1}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="title"
              variant="outlined"
              label="Categoria das Perguntas"
              placeholder="Ex: Dia 1"
              InputLabelProps={{
                shrink: true,
              }}
              value={resource.title}
              onChange={({ target }) => setData(target)}
              fullWidth
            />
          </Grid>
        </Grid>

        <Box display="flex" pb={2} justifyContent="flex-end">
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={() => setStep('items')}
            style={{ height: '55px' }}
          >
            Adicionar Materiais
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
